import type { MessageResponse } from '@/domain/Api';
import type { Item } from '@/domain/Item';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface ItemsResponse extends MessageResponse {
  data: Array<Item>;
}

export interface ItemResponse extends MessageResponse {
  data: Item;
}

export const itemsQuery = (perPage = 1000) =>
  queryOptions({
    queryKey: queryKeys.items.all(),
    queryFn: async () =>
      api
        .get('items', {
          searchParams: {
            per_page: perPage,
          },
        })
        .json<ItemsResponse>(),
  });

export const itemQuery = (itemId: number) =>
  queryOptions({
    queryKey: queryKeys.items.item(itemId),
    queryFn: async () => api.get(`items/${itemId}`).json<ItemResponse>(),
  });
